export const defaultData = {
    name:null,
    total_sum:null,
    income_date:null,
    courier_name:null,
    courier_phone:null,
    branch_id:null,
    vendor_id:null,
    items:[]
}